<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

import WideJobStopEmptyDiagram from '@/components/diagrams/WideJobStopEmptyDiagram.vue';

export interface Props {
  bookedArJob?: ReadonlyDeep<
    NonNullable<openapi.AirroadList2ContentOpenapi['results']>[0]
  >;
}
export type TableFoldProps = Props;
const props = withDefaults(defineProps<Props>(), {
  bookedArJob: undefined,
});

const stops = computed(function () {
  return props.bookedArJob?.stops || [];
});
</script>

<template>
  <section
    data-testid="bookedAirRoadTableFold"
    :class="$style.bookedAirRoadTableFold"
  >
    <!-- TODO similar to @/components/sections/PreviewDiagramNewAirRoadSection.vue -->
    <WideJobStopEmptyDiagram
      :stop-count="stops.length"
      :class="$style.diagram"
    />
    <div :class="$style.stopAddresses">
      <div
        v-for="(stop, stopIndex) in stops"
        :key="stopIndex"
        :class="$style.stopAddress"
      >
        <template v-if="stop && stop.name && stop.state">
          <h4 class="my-0">
            {{ stop.name }},
            {{ stop.state }}
          </h4>
          <!-- TODO similar to @/components/texts/NewAirRoadStopAddressText.vue -->
          <div :class="$style.addressText">
            {{ stop.suburb }},
            {{ stop.postcode }}
            <br />
            {{ stop.address_line_1 }}
            {{ stop.address_line_2 }}
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.bookedAirRoadTableFold {
}
  .diagram {
    margin: 0px 0 12px 0;
  }
  .stopAddresses {
    display: flex;
  }
    .stopAddress {
      width: 100%;
      padding-right: 12px;
    }
  .addressText {
    font-size: 14px;
    line-height: 1.2;

    p {
      margin: 5px 0;
    }
    h4 {
      font-weight: 500;
      color: colors.$color-text-primary;
      margin: 5px 0;
    }
  }
</style>
